// Main entry point for the Achievement System library

// Import all modules
import { AchievementValidation } from './validation';
import { AchievementCalculations } from './calculations';
import { AchievementAPI, AchievementHelpers } from './api';

// Core functionality - re-export classes
export { AchievementValidation } from './validation';
export { AchievementCalculations } from './calculations';
export { AchievementAPI, AchievementHelpers } from './api';

// Re-export types for convenience
export type {
  Achievement,
  AchievementTemplate,
  AchievementProgress,
  UnlockedAchievement,
  CheckAchievementsRequest,
  CheckAchievementsResponse,
  GetAchievementsRequest,
  GetAchievementsResponse,
  AwardAchievementRequest,
  AwardAchievementResponse,
  AchievementStats,
  AchievementCriteria,
  AchievementConditions,
  AchievementTriggerData,
  AchievementCategory,
  AchievementRarity,
  AchievementType,
  AchievementTrigger,
  AchievementTimeframe
} from '../../types/achievement';

export {
  ACHIEVEMENT_TEMPLATES,
  ACHIEVEMENT_VALIDATION,
  ACHIEVEMENT_DISPLAY
} from '../../types/achievement';

// Helper function to initialize the achievement system
export const initializeAchievementSystem = () => {
  console.log('Achievement System initialized');
};

// Export commonly used functions from AchievementHelpers
export const formatAchievementForDisplay = AchievementHelpers.formatAchievementForDisplay;
export const formatTimeAgo = AchievementHelpers.formatTimeAgo;
export const isRecentlyUnlocked = AchievementHelpers.isRecentlyUnlocked;
export const getRarityColor = AchievementHelpers.getRarityColor;
export const getCategoryIcon = AchievementHelpers.getCategoryIcon;
export const sortAchievements = AchievementHelpers.sortAchievements;
export const filterByCategory = AchievementHelpers.filterByCategory;
export const filterByRarity = AchievementHelpers.filterByRarity;
export const getProgressColor = AchievementHelpers.getProgressColor;
export const formatProgressText = AchievementHelpers.formatProgressText;
export const getNotificationMessage = AchievementHelpers.getNotificationMessage;
export const shouldNotify = AchievementHelpers.shouldNotify;
export const groupByCategory = AchievementHelpers.groupByCategory;
export const getSecretAchievementTemplate = AchievementHelpers.getSecretAchievementTemplate;

// Export commonly used functions from AchievementAPI
export const checkAchievements = AchievementAPI.checkAchievements;
export const getAchievements = AchievementAPI.getAchievements;
export const awardAchievement = AchievementAPI.awardAchievement;

// Export commonly used functions from AchievementCalculations
export const calculateCurrentValue = AchievementCalculations.calculateCurrentValue;
export const calculateAchievementStats = AchievementCalculations.calculateAchievementStats;
export const getAchievementsToUnlock = AchievementCalculations.getAchievementsToUnlock;
export const calculateAllProgress = AchievementCalculations.calculateAllProgress;

// Export commonly used functions from AchievementValidation
export const validateTemplate = AchievementValidation.validateTemplate;
export const validateCheckRequest = AchievementValidation.validateCheckRequest;
export const validateAwardRequest = AchievementValidation.validateAwardRequest;
export const getTemplateById = AchievementValidation.getTemplateById;
export const checkConditionsMet = AchievementValidation.checkConditionsMet;
export const calculateProgress = AchievementValidation.calculateProgress;
export const shouldHideAchievement = AchievementValidation.shouldHideAchievement;
export const getDisplayableTemplates = AchievementValidation.getDisplayableTemplates;